import styled, { css } from 'styled-components';

const PlaceholderElementCSS = css`
  display: inline-block;
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.GREY_LIGHT};

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(242, 242, 242, 0) 0,
      rgba(242, 242, 242, 0.2) 20%,
      rgba(242, 242, 242, 0.5) 60%,
      rgba(242, 242, 242, 0)
    );
    animation: waveEffect 2s infinite;
    content: '';

    @keyframes waveEffect {
      100% {
        transform: translateX(100%);
      }
    }
  }
`;

const List = styled.ul`
  background-color: #f2f2f2;
`;

const BasicContainer = styled.div`
  width: 100%;
  height: 24px;

  ${PlaceholderElementCSS};
`;

const ListItem = styled.li`
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  display: flex;
  background-color: #ffffff;
`;

const TitleContainer = styled.div`
  width: 25%;
  height: 16px;

  ${PlaceholderElementCSS};
`;

const TitleListItem = styled.li`
  padding: ${({ theme }) => `${theme.spacing.S4} ${theme.spacing.M16}`};
  display: flex;
  background-color: #f3f4f7;
`;

export { List, ListItem, BasicContainer, TitleContainer, TitleListItem };
